var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1277"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1277"
    },
    "bundlingPackage": "documents-public-ui",
    "bundlingPackageVersion": "static-1.35553",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};